import { type FC, type PropsWithChildren } from 'react';

const ApprovalSection: FC<PropsWithChildren> = ({ children }) => <div className="ui-card pa3 mb4 mw7">{children}</div>;

export default ApprovalSection;
